<template>
  <div class="o-reset-password container">
    <div class="row">
      <div class="col-12 col-md-6 offset-md-3">
        <h2 class="h4 o-reset-password__headline">
          {{ $t('resetPasswordHeadline', 'Nulstil adgangskode') }}
        </h2>
        <p v-if="isTokenVerified && !isTokenValid">
          {{ $t('resetPasswordLinkInvalidMessage', 'Linket til nulstilling af din adgangskode var ugyldigt, sandsynligvis fordi det allerede er blevet brugt. Anmod venligst om et nyt link til at nulstille din adgangskode.') }}
        </p>
        <template v-else>
          <template v-if="!showSuccessMessage">
            <base-input
              :ref="'newPassword'"
              v-model="formData.newPassword"
              v-validate="'required|min:8'"
              type="password"
              :label="$t('resetPasswordNewPassword', 'Ny adgangskode')"
              name="newpassword"
              :custom-error-messages="{
                'required': $t('resetPasswordNewPasswordRequiredErrorMessage', 'Udfyld venligst en gyldig adgangskode'),
                'min': $t('resetPasswordNewPasswordMinErrorMessage', 'Adgangskoden skal være på minimum 8 karakterer'),
              }"
              :show-feedback-icon="true"
              :aria-label="$t('resetPasswordNewPassword', 'Ny adgangskode')"
              required
              class="-with-validation"
            />
            <base-input
              v-model="formData.newPasswordConfirm"
              v-validate="'required|confirmed:newPassword'"
              type="password"
              :label="$t('resetPasswordNewPasswordConfirm', 'Bekræft ny adgangskode')"
              name="newpasswordconfirm"
              :error-message="$t('resetPasswordNewPasswordConfirmRequiredErrorMessage', 'Adgangskode svarer ikke til hinanden')"
              :show-feedback-icon="true"
              :aria-label="$t('resetPasswordNewPasswordConfirm', 'Bekræft ny adgangskode')"
              required
              class="-with-validation"
            />
            <button-with-loader
              :loading="isLoading"
              :text="$t('resetPasswordButtonText', 'Skift adgangskode')"
              class="-secondary -wide mt-3"
              @click.native="resetPassword"
            />
            <div v-if="showError" class="col-md-12 d-flex fade-in mt-4">
              <p class="bg-red color-white p-4 d-block">
                <span class="semibold pb-2 d-block">{{ $t('sorry','Vi beklager') }}</span>
                {{ $t('resetPasswordError','Der skete desværre en fejl, prøv igen senere.') }}
              </p>
            </div>
          </template>
          <div v-else>
            {{ $t('resetPasswordSuccessMessage', 'Tillykke! Din adgangskode er nu blevet ændret.') }}
            <base-link :link="loginLink">
              {{ $t('resetPasswordSuccessLinkText', 'Gå til login-siden') }}
            </base-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/atoms/BaseInput';
import ButtonWithLoader from '@/components/molecules/ButtonWithLoader';
import BaseLink from '../atoms/BaseLink.vue';

export default {
  name: 'ResetPassword',
  components: {
    BaseInput,
    ButtonWithLoader,
    BaseLink
  },
  async fetch () {
    if (!this.secret || !this.email) {
      this.isTokenVerified = true;
      return;
    }

    try {
      const data = await this.$repositories.authentication.isSecretValid(this.email, this.secret);
      if (!data.isValid) {
        this.isTokenVerified = true;
        this.isTokenValid = false;
        return;
      }

      this.isTokenVerified = true;
      this.isTokenValid = true;
    } catch (error) {
      this.isTokenVerified = true;
      this.isTokenValid = false;
    }
  },
  data () {
    return {
      formData: {
        newPassword: '',
        newPasswordConfirm: '',
      },
      isTokenVerified: false,
      isTokenValid: false,
      isLoading: false,
      showError: false,
      showSuccessMessage: false,
    }
  },
  computed: {
    secret () {
      return this.$route.query.key;
    },
    email () {
      return this.$route.query.id;
    },
    loginLink () {
      return this.$store.getters['site/getSiteSettings']?.loginLink?.url;
    }
  },
  methods: {
    async resetPassword () {
      this.isLoading = true;
      this.showError = false;
      const allFieldsValid = await this.$validator.validate();

      if (!allFieldsValid) {
        this.isLoading = false;
        return;
      }

      try {
        const data = await this.$repositories.authentication.recoverPassword(this.email, this.secret, this.formData);

        if (data && !data.isValid) {
          this.showError = true;
          this.isLoading = false;
          return;
        }

        this.showSuccessMessage = true;
      } catch (error) {
        this.showError = true;
      }

      this.isLoading = false;
    }
  }
}
</script>
